export const link = (link: string) => {
  if (link.startsWith('http')) {
    return link;
  }
  if (link.startsWith('/')) {
    return link;
  }
  return `/${link}`;
};
